import { site } from "@/config/site";
import api from "@/lib/api";

// Meta's standard events (used for ad conversion optimisation). Everything else
// is sent as a custom event. Keeping Lead/PageView as standard events lets Meta
// Ads Manager measure and optimise toward conversions out of the box.
const META_STANDARD = new Set(["PageView", "Lead", "ViewContent", "Contact", "Schedule", "CompleteRegistration"]);

// Fires analytics events to Meta Pixel + GA4 (gtag) + GTM dataLayer if configured,
// and always records a lightweight server-side funnel event. Site works fully with
// no analytics configured — these are no-ops until IDs are added in config/site.js.
export function trackEvent(event, meta = {}) {
  try {
    if (window.fbq) {
      if (META_STANDARD.has(event)) window.fbq("track", event, meta);
      else window.fbq("trackCustom", event, meta);
    }
    if (window.gtag) window.gtag("event", event, meta);
    if (window.dataLayer) window.dataLayer.push({ event, ...meta });
  } catch (e) {
    /* analytics must never break the app */
  }
  // Server-side funnel record (best-effort)
  api.post("/track", { event, meta }).catch(() => {});
}

export const EVENTS = {
  PAGE_VIEW: "PageView",
  VIEW_SERVICE: "ViewService",
  START_ASSESSMENT: "StartAssessment",
  COMPLETE_ASSESSMENT: "CompleteAssessment",
  LEAD: "Lead",
  WHATSAPP_CLICK: "WhatsAppClick",
  PHONE_CLICK: "PhoneClick",
  CONSULTATION_REQUEST: "ConsultationRequest",
};

// Injects Meta Pixel / GA4 / GTM scripts only when IDs exist in config.
export function initAnalytics() {
  const { metaPixelId, ga4MeasurementId, gtmId } = site.analytics;

  if (gtmId) {
    window.dataLayer = window.dataLayer || [];
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(s);
  }
  if (ga4MeasurementId) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4MeasurementId}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", ga4MeasurementId);
  }
  if (metaPixelId) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0";
      n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", metaPixelId);
    window.fbq("track", "PageView");
    /* eslint-enable */
  }
}
